module.exports = __webpack_public_path__ + "static/img/1_8_1.b81839cf.jpg";